import random from 'lodash/random'
import {v4 as uuidv4} from 'uuid'

export function toPercent(num: number, fractionDigits = 1) {
  return `${Number((num * 100).toFixed(fractionDigits))}%`
}

// 数组中随机取一个
// [1,2,3,4] => 1 || 2|| 3 || 4
export function randomInArray(arr = []) {
  return arr[random(0, arr.length - 1)]
}
// 顶 踩 赞 分享 格式化
// 100 => 100   11111 => 1.1w 50000 => 5w
export function postNumber(num, placeholder = 0, max = 10000, fixed = 1) {
  if (!num) return placeholder || 0
  if (num >= max) return `${Number((num / 10000).toFixed(fixed))}w`
  return num
}

// 计算单个图片的宽高
export function singleImgSize(w = 150, h = 200) {
  const MAX = 240
  const MIN = 100
  const MAX_RATE = MAX / MIN
  const MIN_RATE = MIN / MAX
  let finalW
  let finalH
  if (w / h < MIN_RATE) {
    finalW = MIN
    finalH = MAX
  } else if (w / h > MAX_RATE) {
    finalW = MAX
    finalH = MIN
  } else if (w >= h) {
    finalW = MAX
    finalH = h / (w / MAX)
  } else if (w < h) {
    finalW = w / (h / MAX)
    finalH = MAX
  }
  return [Math.round(finalW), Math.round(finalH)]
}

// 媒体时长
// 10 => 00:10
export function mediaDur(dur = 0) {
  const tempMinutes = Math.floor(dur / 60)
  const tempSecond = Math.floor(dur % 60)
  const minutes = tempMinutes > 9 ? tempMinutes : `0${tempMinutes}`
  const second = tempSecond > 9 ? tempSecond : `0${tempSecond}`
  return `${minutes}:${second}`
}

export const generateUniqueUUID = (id, name) => {
  // const namespace = '1b671a64-40d5-491e-99b0-da01ff1f3341'
  const uniqueId = uuidv4(`${id}-${name}`)

  return uniqueId
}
